import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'solutions-manager',
  template: `
    <p>it working</p>
    <router-outlet></router-outlet>
  `,
  styles: [],
})
export class SolutionsManagerComponent {
  title: string = 'Solutions Manager';
  name: string | any = '';
  constructor(public route: ActivatedRoute) {}
}
